export const comments_5256811 = {"data":{"data":[],"links":{}}}